module.exports = __webpack_public_path__ + "img/firstHistory-icon2.36de0c85.png";